/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTeamMemberAvailability} from '../api'

export const useMutationUpdateTeamMemberAvailability = createReactQueryMutationHook('updateTeamMemberAvailability', updateTeamMemberAvailability)
